import {PseudoStateKey} from '@packages/systems/core/utils/StyleTypes';

// This attribute is used by the Intellimize Client JS bundle.
// Keep this attribute in sync with the Client JS bundle + this function: https://github.com/webflow/webflow/blob/97f52d23d3fa56add54827a164df57b534d0e072/packages/systems/style-legacy/selectors/index.ts#L45-L47
export const createCurrentVariationDataAttribute = (
  variationId: string
): PseudoStateKey => {
  return `data-intellimize-var-${variationId}`;
};
